const LoginPage = (props: any) => {
  return (
    <div className={'flex w-full h-full justify-center items-center bg-gray-100'}>
      <div>Login MVP</div>
    </div>
  );
};

export default LoginPage;
